import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import type ViewType from '../store/schema/ViewType';
import getAppropriateReadingPaneViewType from '../utils/getAppropriateReadingPaneViewType';

const setMailOrganizationViewTypesMutator: (
    messageListExpansionType: ViewType,
    readingPaneViewType: ViewType
) => void = mutatorAction(
    'setMailOrganizationViewTypes',
    (messageListExpansionType: ViewType, readingPaneViewType: ViewType): void => {
        const store = getStore();
        if (messageListExpansionType != 3) {
            store.messageListExpansionType = messageListExpansionType;
        }

        if (readingPaneViewType != 3) {
            store.readingPaneViewType = getAppropriateReadingPaneViewType(
                store.messageListExpansionType,
                readingPaneViewType
            );
        }
    }
);
export default setMailOrganizationViewTypesMutator;
